import "../../style/scss/App.scss";
import { DateTime } from "luxon";

export default function AdminAgreementListItem({ agreement, onView }) {
  const a = agreement || {};
  const id = a.ID ?? a.id;
  const killDate = a.KillDate ? DateTime.fromISO(a.KillDate).toFormat("MM/yyyy") : "N/A";
  const activeDate = a.ActiveDate ? DateTime.fromISO(a.ActiveDate).toFormat("MM/yyyy") : "N/A";
  const version =
    a.Version ||
    (a.MajorVersion != null ? `${a.MajorVersion}.${a.MinorVersion ?? 0}` : null);
  const typeName = a.TypeName || a.typeName || "";
  const requiredForLogin = !!(a.RequiredForLogin ?? a.requiredForLogin);

  return (
    <li key={id}>
      <button
        type="button"
        className="centered skillLink location-list-item"
        data-testid={`admin-agreement-list-item-${id}`}
        onClick={() => onView?.(a)}
      >
        <div className="Job mobilePanel">
          <span className="title">{a.Name || a.name || "Agreement"}</span>
          <span className="rightText">
            {typeName ? `${typeName} · ` : ""}
            {version ? `v${version} · ` : ""}
            {requiredForLogin ? "Login required · " : ""}
            From: {activeDate} to {killDate}
          </span>
        </div>
      </button>
    </li>
  );
}
